import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ErrorBoundary from './ErrorBoundary';
import logo from '../assets/logo.png';
import './Layout.css';

const NAV_ITEMS = [
  { to: '/', label: 'Overview', end: true },
  { to: '/finances', label: 'Accounting' },
  { to: '/lab', label: 'Lab' },
  { to: '/production', label: 'Production' },
  { to: '/products', label: 'Products' },
  { to: '/invoices', label: 'Invoices' },
  { to: '/suppliers', label: 'Suppliers & Orders' },
  { to: '/todo', label: 'To-Do' },
  { to: '/marketing', label: 'Marketing' },
];

export default function Layout() {
  const { user, signOut } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Close on navigation. Without this, tapping a link on a phone leaves the
  // rail covering the page you just asked for.
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Escape closes it too — the drawer is modal on small screens.
  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e) => e.key === 'Escape' && setMenuOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [menuOpen]);

  return (
    <div className="app-shell">
      {/* Only rendered on small screens (CSS), where the rail is off-canvas
          and there would otherwise be no way to reach the nav at all. */}
      <header className="mobile-bar">
        <button
          className="mobile-menu-button"
          onClick={() => setMenuOpen(true)}
          aria-label="Open navigation"
          aria-expanded={menuOpen}
        >
          <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
            <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
        </button>
        <img src={logo} alt="" className="mobile-logo" />
        <span>Skin Fairy JA</span>
      </header>

      {menuOpen && (
        <div className="sidebar-scrim" onClick={() => setMenuOpen(false)} aria-hidden="true" />
      )}

      <aside className={'sidebar' + (menuOpen ? ' open' : '')}>
        <div className="sidebar-brand">
          <img src={logo} alt="Skin Fairy JA" className="sidebar-logo" />
          <span>Skin Fairy JA</span>
          <button
            className="sidebar-close"
            onClick={() => setMenuOpen(false)}
            aria-label="Close navigation"
          >
            ×
          </button>
        </div>
        <nav className="sidebar-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => 'sidebar-link' + (isActive ? ' active' : '')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="sidebar-user">{user?.email}</div>
          <button className="sidebar-signout" onClick={signOut}>
            Sign out
          </button>
        </div>
      </aside>

      <main className="app-content">
        {/* Keyed on the path so navigating away from a failed section clears
            the error — otherwise one bad page would keep showing its failure
            over every page you visited next. */}
        <ErrorBoundary key={location.pathname} label="this section">
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
